module.exports = __webpack_public_path__ + "static/cars-3c6dc96b317a340a9b6fbe2b4c74c01c.png";